export default "__VITE_ASSET__BFSMJuzP__"